import { render, staticRenderFns } from "./listaLocal.vue?vue&type=template&id=0512aa7f&scoped=true&"
import script from "./listaLocal.vue?vue&type=script&lang=js&"
export * from "./listaLocal.vue?vue&type=script&lang=js&"
import style0 from "./listaLocal.vue?vue&type=style&index=0&id=0512aa7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512aa7f",
  null
  
)

export default component.exports